/**
 * @generated SignedSource<<906aea84130815f57ba684bfe86caf97>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteBrainSearchButtonFragment$data = {
  readonly contentUsage: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly organizationId: string;
  readonly " $fragmentType": "DeleteBrainSearchButtonFragment";
};
export type DeleteBrainSearchButtonFragment$key = {
  readonly " $data"?: DeleteBrainSearchButtonFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DeleteBrainSearchButtonFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeleteBrainSearchButtonFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsage",
      "kind": "LinkedField",
      "name": "contentUsage",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "BrainSearch",
  "abstractKey": null
};
})();

(node as any).hash = "bb1064ee40b784eceeddd002061b8548";

export default node;
